module.exports = __webpack_public_path__ + "img/carl-shurz.4aa66cc9.png";